import React, { PropTypes, Component, Fragment } from 'react'
import api from '../../../apiClient/v1'

export default class TurnoEmergencia extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }

        this.onChange = (e) => {
            const checked = e.target.checked;
            api.nomina(this.props.nomina.idNomina).changeTurnoEmergencia(checked)
                .then((response) => {
                    console.log(response)
                }).catch((error) => {
                    console.log(error)
                    const nomina = {
                        ...this.props.nomina,
                        "turno_emergencia": !checked
                    }
                    this.context.updateNomina(nomina)
                })
            const nomina = {
                ...this.props.nomina,
                "turno_emergencia": checked
            }
            this.context.updateNomina(nomina)
        }
    }
    render() {
        const checked = this.props.nomina.turno_emergencia
        return (
            <div>
                <label style={{
                    display: 'inline-block',
                    marginRight: '5px'
                }}>
                    <input type='checkbox' checked={checked} onChange={this.onChange} />
                    Turno Emergencia
                </label>
            </div>
        )
    }
}

TurnoEmergencia.contextTypes = {
    updateNomina: PropTypes.func
}



// WEBPACK FOOTER //
// ./frontEnd/nominas/nominaIG/turnoEmergencia/TurnoEmergencia.jsx